import {
  Box,
  Text,
  Heading,
  SimpleGrid,
  HStack,
  Button,
  Image,
  Flex,
  useColorModeValue,
  Stack,
} from "@chakra-ui/react";
import { FaAngleRight } from "react-icons/fa";
import SidebarWithHeader from "components/SidebarWithHeader";
import { useNavigate } from "react-router-dom";

import Cashback from "../assets/images/AboutRentIcon/Cashback.png";
import Suport from "../assets/images/AboutRentIcon/support.png";
import Instant from "../assets/images/AboutRentIcon/Instant Top Up.png";
import HighScore from "../assets/images/AboutRentIcon/High Score.png";
import DebitCard from "../assets/images/AboutRentIcon/Debit_Credit_Amex.png";
import RequestNew from "../assets/images/AboutRentIcon/Request an Ad Account.png";
import RegisterCompaney from "../assets/images/AboutRentIcon/Register & Verify_Company.png";
import TopUp from "../assets/images/AboutRentIcon/Top Up.png";
import LaunchAds from "../assets/images/AboutRentIcon/Launch Ad campaign via_Adspresso.png";

const features = [
  { img: Cashback, title: "Get % Cashback On Your Ad Spends" },
  { img: Suport, title: "24/7 Support across Worldwide Time Zones" },
  {
    img: Instant,
    title: "Instant Top Up Based On Transaction Screenshot Itself",
  },
  {
    img: HighScore,
    title: "High Score Business Manager With Better CPMs & CPAs",
  },
  { img: DebitCard, title: "Attach Your Own Debit/Credit/Amex Cards + PayPal" },
];

const steps = [
  { img: RegisterCompaney, label: "Register & Verify Company" },
  { img: RequestNew, label: "Request an Ad Account" },
  { img: TopUp, label: "Top Up" },
  { img: LaunchAds, label: "Launch Ad campaign via Adspresso" },
];

const AboutForRentAccount = () => {
  const navigate = useNavigate();

  const textColor = useColorModeValue("brand.900", "brand.500");
  const subTextColor = useColorModeValue("gray.600", "gray.400");
  const iconBg = useColorModeValue("white", "card.dark");
  const borderColor = useColorModeValue("brand.900", "brand.500");
  const TastBgg = useColorModeValue("white", "card.dark");

  return (
    <SidebarWithHeader>
      <Box
        px={6}
        mt="20px"
        maxW="6xl"
        mx="auto"
        textAlign="center"
        color={textColor}
      >
        <Heading as="h1" size="xl" mb={2}>
          Rent Ad Accounts
        </Heading>

        <Text fontSize="md" color={subTextColor} mb={10}>
          We provide Stable Agency Accounts
        </Text>

        <Heading size="md" mb={6}>
          What you need to do
        </Heading>

        <Stack
          spacing={{ base: 10, md: 0 }}
          justify="center"
          mb={8}
          direction={{ base: "column", md: "row" }}
          align="center"
        >
          {steps.map((step, index) => (
            <Flex
              key={index}
              align="center"
              direction={{ base: "column", md: "row" }}
            >
              <Flex
                direction="column"
                align="center"
                w="160px"
                minH="150px"
                mx={{ md: 2 }}
                mb={{ base: 4, md: 0 }}
              >
                <Box position="relative" mb={2}>
                  <Box
                    w="80px"
                    h="80px"
                    borderRadius="full"
                    bg={iconBg}
                    border="2px solid"
                    borderColor={borderColor}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Image
                      src={step.img}
                      alt={step.label}
                      width={{ base: "30px", md: "40px" }}
                    />
                  </Box>

                  {index < steps.length - 1 && (
                    <Box
                      display={{ base: "none", md: "flex" }}
                      position="absolute"
                      top="40px"
                      right="-100px"
                      height="2px"
                      width="100px"
                      bg={borderColor}
                    >
                      <Box position="absolute" right="35%" top="-6px">
                        <FaAngleRight color={borderColor} size="14px" />
                      </Box>
                    </Box>
                  )}
                </Box>
                <Text textAlign="center" fontSize="sm">
                  {step.label}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Stack>

        <Heading size="md" mt={8} mb={6}>
          Why us
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} mb={10}>
          {features.map((feature, index) => (
            <Box
              key={index}
              p={8}
              borderRadius="lg"
              textAlign="left"
              border={`1px solid`}
              borderColor={borderColor}
              bg={TastBgg}
              backdropFilter="blur(10px)"
            >
              <HStack spacing={4}>
                <Image
                  src={feature.img}
                  alt={feature.title}
                  width={{ base: "30px", md: "50px" }}
                />
                <Text fontWeight="bold">{feature.title}</Text>
              </HStack>
            </Box>
          ))}
        </SimpleGrid>

        <Text fontWeight="bold" color={textColor} mb={4}>
          So, why wait? Get started now!
        </Text>

        <Button
          size="sm"
          borderRadius="md"
          colorScheme="brand"
          bgGradient="linear(to-r, brand.400, brand.500)"
          _hover={{
            bgGradient: "linear(to-r, brand.500, brand.600)",
          }}
          color="white"
          onClick={() => navigate("/accounts")}
        >
          Let's go
        </Button>
      </Box>
    </SidebarWithHeader>
  );
};

export default AboutForRentAccount;